import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Play, FileText, Users, Share2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface MetricsDashboardProps {
  totalTests: number;
  activeTests: number;
  totalResponses: number;
  sharedTests: number;
}

export const MetricsDashboard = ({ 
  totalTests, 
  activeTests, 
  totalResponses, 
  sharedTests 
}: MetricsDashboardProps) => {
  const metrics = [
    {
      title: "Total Tests",
      value: totalTests,
      icon: FileText,
      color: "text-blue-600 dark:text-blue-400",
      bgColor: "bg-blue-50 dark:bg-blue-950/50"
    },
    {
      title: "Active Tests",
      value: activeTests,
      icon: Play,
      color: "text-green-600 dark:text-green-400",
      bgColor: "bg-green-50 dark:bg-green-950/50"
    },
    {
      title: "Total Responses",
      value: totalResponses,
      icon: Users,
      color: "text-purple-600 dark:text-purple-400",
      bgColor: "bg-purple-50 dark:bg-purple-950/50"
    },
    {
      title: "Shared with You",
      value: sharedTests,
      icon: Share2,
      color: "text-orange-600 dark:text-orange-400",
      bgColor: "bg-orange-50 dark:bg-orange-950/50"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {metrics.map((metric) => {
        const Icon = metric.icon;
        return (
          <Card key={metric.title} className="border-border">
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium text-muted-foreground">
                {metric.title}
              </CardTitle>
              <div className={`rounded-full p-2 ${metric.bgColor}`}>
                <Icon className={`h-4 w-4 ${metric.color}`} />
              </div>
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold text-foreground">
                {metric.value.toLocaleString()}
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};